import React from 'react';

import { getImgixImageData } from "@utils";



import {
  DEIHero,
  DEIPageHeroContentDIV,
  DEIPageHeroDIV,
  DEIPageHeroIMG,
  DEIPageHeroImgWrapperDIV,
  DEIPageMobileHeroIMG,
} from './DEIPageHero.styles';

const DEIPageHero = () => (
  <DEIHero style={{ overflow: 'visible' }}>
    <DEIPageHeroDIV>
      <div className="container">
        <DEIPageHeroContentDIV>
          <h1>Diversity, Equity &amp;&nbsp;Inclusion</h1>
          <p className="type--text-L">We believe that when teams represent different backgrounds, perspectives, and experiences, magic happens. The result is better products and a culture that enables everyone to bring their authentic selves to work.</p>
        </DEIPageHeroContentDIV>
      </div>
      <DEIPageHeroImgWrapperDIV>
        <DEIPageHeroIMG
          alt=""
          image={getImgixImageData(
            '/images/pages/dei/DEIPageHero--hero-stripe--desktop.png',
            1920,
            1920 / 1027
          )}
          role="presentation"
        />
      </DEIPageHeroImgWrapperDIV>
      <DEIPageMobileHeroIMG
        alt=""
        image={getImgixImageData(
          '/images/pages/dei/DEIPageHero--hero-stripe--mobile.png',
          768,
          2.33
        )}
        role="presentation"
      />
    </DEIPageHeroDIV>
  </DEIHero>
);


export default DEIPageHero;
